import { Text } from '@ltvco/refresh-lib/theme';
import { AddeptIo, ReportSection } from '@ltvco/refresh-lib/v2';

export const AddeptIoContainer = () => {
  return (
    <ReportSection
      sectionId="addept-io"
      hasContent={true}
      title="Bumper Rewards"
      titleSx={{
        fontSize: '1.5rem',
      }}
      hideSectionOptions
    >
      <Text variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        With your Bumper membership, you get access to exclusive rewards and
        special offers. Enjoy added value beyond your vehicle reports.
      </Text>
      <AddeptIo />
      <Text
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', pb: 2, mt: 1.5 }}
      >
        Advertising Disclaimer: Certain products and services, including vehicle
        purchase/sale opportunities, provided above include offers from third
        parties and/or external partners from whom we may receive limited
        compensation. Please be advised that these offers are provided as a
        convenience and are a sample, but do not necessarily include ALL offers,
        products or services available in the marketplace.
      </Text>
    </ReportSection>
  );
};
